module.exports = __webpack_public_path__ + "img/esfj.0bf61843.png";